import { styled } from 'baseui'

export const AskLineButton = styled('button', ({ $theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '0.625rem',
  width: '100%',
  boxSizing: 'border-box',
  paddingTop: '0.625rem',
  paddingBottom: '0.625rem',
  paddingLeft: '0.75rem',
  paddingRight: '0.75rem',
  border: 0,
  borderRadius: '1rem',
  backgroundColor: 'transparent',
  cursor: 'text',
  textAlign: 'left',
  ':focus-visible': { outline: `2px solid ${$theme.colors.primary}`, outlineOffset: '2px' },
}))

export const AskField = styled('span', ({ $theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '0.375rem',
  flexGrow: 1,
  minWidth: 0,
  paddingTop: '0.4375rem',
  paddingBottom: '0.4375rem',
  paddingLeft: '0.75rem',
  paddingRight: '0.5rem',
  border: `1px solid ${$theme.colors.borderInput}`,
  borderRadius: '999px',
  backgroundColor: $theme.colors.white,
  color: $theme.colors.contentSecondary,
  fontSize: '0.8125rem',
  lineHeight: '1.25rem',
}))

export const AskPlaceholder = styled('span', {
  flexGrow: 1,
  minWidth: 0,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
})

export const ShortcutKey = styled('kbd', ({ $theme }) => ({
  flexShrink: 0,
  paddingLeft: '0.375rem',
  paddingRight: '0.375rem',
  border: `1px solid ${$theme.colors.borderInput}`,
  borderRadius: '0.375rem',
  backgroundColor: $theme.colors.bg050,
  color: $theme.colors.contentSecondary,
  fontFamily: 'inherit',
  fontSize: '0.6875rem',
  fontWeight: 600,
  lineHeight: '1.125rem',
  whiteSpace: 'nowrap',
}))
